module.exports = __webpack_public_path__ + "static/media/PDF.1a81c415.svg";